import { STORE_SERVICES } from '../../../../../views/phone-answering/constants';

export default {
  title: 'Palvelut',
  options: {
    [STORE_SERVICES.CATERING]: 'Pitopalvelu',
    [STORE_SERVICES.TERRACE]: 'Terassi käytettävissä',
    [STORE_SERVICES.DINE_IN]: 'Ruokailu paikan päällä',
    [STORE_SERVICES.ONLINE_ORDERING]: 'Verkkotilaus FoodAmigosin kautta',
    [STORE_SERVICES.RESERVATION]: 'Varaukset FoodAmigosin kautta',
    [STORE_SERVICES.INTERNAL_RESERVATION]: 'Varaukset ravintolassa',
  },
  labels: {
    reservation_total_seats: 'Varauksen kokonaispaikkamäärä',
    catering_min_people: 'Pitopalvelun vähimmäishenkilömäärä',
  },
};
